/**
 * Offline snapshot, generated by `npm run seed` from the official FDJ archives.
 * DO NOT EDIT BY HAND.
 *
 * This is a cache, not the source of truth: the Worker and its D1 database are. It
 * exists so the app shows something real on first launch and in airplane mode, and
 * so the Statistics screen has two full rolling windows to compare before any
 * ingestion has happened. Trimmed to 30 months; the Worker serves the full history.
 *
 * These counts are a DIAGNOSTIC. They are never fed into grid generation.
 */
import type { GameKey } from '../engine';

export interface SeedDraw {
  /** YYYY-MM-DD */
  readonly date: string;
  readonly main: readonly number[];
  readonly bonus: readonly number[];
}

/** The day the snapshot was generated, so the UI can say how old it is. */
export const SEED_GENERATED_AT = '2026-09-03';

export const SEED_DRAWS: { readonly [K in GameKey]: readonly SeedDraw[] } = {
  loto: [
    { date: '2024-03-02', main: [13, 17, 20, 26, 27], bonus: [4] },
    { date: '2024-03-04', main: [8, 18, 25, 27, 37], bonus: [8] },
    { date: '2024-03-06', main: [8, 12, 43, 46, 49], bonus: [8] },
    { date: '2024-03-09', main: [7, 25, 28, 29, 35], bonus: [2] },
    { date: '2024-03-11', main: [16, 18, 36, 45, 48], bonus: [10] },
    { date: '2024-03-13', main: [4, 5, 10, 13, 29], bonus: [1] },
    { date: '2024-03-16', main: [10, 12, 25, 37, 49], bonus: [2] },
    { date: '2024-03-18', main: [20, 30, 36, 40, 48], bonus: [8] },
    { date: '2024-03-20', main: [3, 22, 24, 32, 46], bonus: [5] },
    { date: '2024-03-23', main: [20, 32, 34, 47, 49], bonus: [1] },
    { date: '2024-03-25', main: [1, 22, 26, 31, 37], bonus: [5] },
    { date: '2024-03-27', main: [2, 15, 23, 28, 45], bonus: [7] },
    { date: '2024-03-30', main: [8, 28, 40, 41, 42], bonus: [2] },
    { date: '2024-04-01', main: [9, 12, 15, 17, 26], bonus: [8] },
    { date: '2024-04-03', main: [5, 12, 26, 36, 46], bonus: [4] },
    { date: '2024-04-06', main: [2, 6, 27, 36, 43], bonus: [5] },
    { date: '2024-04-08', main: [2, 21, 22, 46, 49], bonus: [9] },
    { date: '2024-04-10', main: [1, 9, 18, 33, 39], bonus: [2] },
    { date: '2024-04-13', main: [7, 19, 29, 38, 45], bonus: [8] },
    { date: '2024-04-15', main: [2, 21, 24, 31, 36], bonus: [6] },
    { date: '2024-04-17', main: [6, 8, 17, 24, 48], bonus: [10] },
    { date: '2024-04-20', main: [10, 13, 16, 22, 24], bonus: [7] },
    { date: '2024-04-22', main: [8, 20, 39, 47, 48], bonus: [1] },
    { date: '2024-04-24', main: [25, 38, 39, 40, 41], bonus: [7] },
    { date: '2024-04-27', main: [14, 18, 27, 34, 44], bonus: [6] },
    { date: '2024-04-29', main: [3, 20, 30, 47, 49], bonus: [7] },
    { date: '2024-05-01', main: [5, 15, 17, 25, 42], bonus: [7] },
    { date: '2024-05-04', main: [2, 6, 12, 16, 19], bonus: [3] },
    { date: '2024-05-06', main: [1, 4, 21, 35, 39], bonus: [5] },
    { date: '2024-05-08', main: [3, 6, 7, 34, 36], bonus: [7] },
    { date: '2024-05-11', main: [6, 13, 24, 39, 43], bonus: [8] },
    { date: '2024-05-13', main: [12, 13, 18, 25, 26], bonus: [4] },
    { date: '2024-05-15', main: [9, 15, 16, 20, 21], bonus: [1] },
    { date: '2024-05-18', main: [14, 15, 34, 37, 45], bonus: [2] },
    { date: '2024-05-20', main: [6, 12, 29, 32, 36], bonus: [8] },
    { date: '2024-05-22', main: [20, 21, 23, 32, 46], bonus: [10] },
    { date: '2024-05-25', main: [18, 19, 20, 26, 42], bonus: [1] },
    { date: '2024-05-27', main: [19, 32, 41, 42, 47], bonus: [1] },
    { date: '2024-05-29', main: [10, 19, 28, 37, 38], bonus: [7] },
    { date: '2024-06-01', main: [2, 3, 27, 43, 48], bonus: [8] },
    { date: '2024-06-03', main: [9, 15, 39, 48, 49], bonus: [7] },
    { date: '2024-06-05', main: [4, 6, 7, 35, 47], bonus: [1] },
    { date: '2024-06-08', main: [18, 31, 35, 39, 43], bonus: [7] },
    { date: '2024-06-10', main: [5, 28, 34, 39, 47], bonus: [8] },
    { date: '2024-06-12', main: [3, 6, 13, 28, 33], bonus: [4] },
    { date: '2024-06-15', main: [8, 16, 30, 40, 42], bonus: [2] },
    { date: '2024-06-17', main: [6, 11, 25, 28, 46], bonus: [2] },
    { date: '2024-06-19', main: [11, 18, 30, 35, 46], bonus: [2] },
    { date: '2024-06-22', main: [10, 25, 29, 34, 38], bonus: [3] },
    { date: '2024-06-24', main: [1, 6, 45, 47, 48], bonus: [6] },
    { date: '2024-06-26', main: [10, 21, 25, 38, 41], bonus: [8] },
    { date: '2024-06-29', main: [1, 17, 24, 30, 43], bonus: [7] },
    { date: '2024-07-01', main: [3, 6, 7, 22, 28], bonus: [7] },
    { date: '2024-07-03', main: [1, 4, 21, 24, 42], bonus: [3] },
    { date: '2024-07-05', main: [3, 5, 7, 11, 12], bonus: [2] },
    { date: '2024-07-06', main: [13, 18, 34, 46, 47], bonus: [5] },
    { date: '2024-07-08', main: [7, 8, 24, 31, 42], bonus: [6] },
    { date: '2024-07-10', main: [3, 5, 11, 16, 39], bonus: [9] },
    { date: '2024-07-13', main: [5, 6, 21, 24, 42], bonus: [8] },
    { date: '2024-07-15', main: [4, 10, 24, 30, 38], bonus: [10] },
    { date: '2024-07-17', main: [6, 17, 35, 40, 47], bonus: [4] },
    { date: '2024-07-20', main: [5, 15, 16, 30, 47], bonus: [7] },
    { date: '2024-07-22', main: [25, 27, 35, 42, 49], bonus: [9] },
    { date: '2024-07-24', main: [8, 11, 18, 40, 47], bonus: [2] },
    { date: '2024-07-26', main: [2, 18, 26, 45, 47], bonus: [7] },
    { date: '2024-07-27', main: [8, 21, 28, 42, 47], bonus: [4] },
    { date: '2024-07-29', main: [20, 22, 31, 32, 34], bonus: [7] },
    { date: '2024-07-31', main: [3, 25, 45, 47, 49], bonus: [7] },
    { date: '2024-08-03', main: [2, 4, 14, 34, 47], bonus: [2] },
    { date: '2024-08-05', main: [7, 21, 24, 27, 31], bonus: [3] },
    { date: '2024-08-07', main: [24, 27, 39, 46, 47], bonus: [9] },
    { date: '2024-08-10', main: [17, 28, 31, 36, 37], bonus: [10] },
    { date: '2024-08-12', main: [16, 18, 31, 38, 45], bonus: [8] },
    { date: '2024-08-14', main: [17, 23, 25, 28, 46], bonus: [5] },
    { date: '2024-08-17', main: [3, 4, 22, 48, 49], bonus: [1] },
    { date: '2024-08-19', main: [10, 18, 19, 20, 28], bonus: [5] },
    { date: '2024-08-21', main: [3, 15, 19, 20, 31], bonus: [7] },
    { date: '2024-08-24', main: [13, 20, 29, 30, 36], bonus: [5] },
    { date: '2024-08-26', main: [3, 6, 12, 24, 28], bonus: [2] },
    { date: '2024-08-28', main: [11, 30, 33, 37, 42], bonus: [3] },
    { date: '2024-08-31', main: [14, 18, 28, 40, 43], bonus: [1] },
    { date: '2024-09-02', main: [5, 6, 12, 26, 27], bonus: [6] },
    { date: '2024-09-04', main: [2, 4, 22, 26, 40], bonus: [8] },
    { date: '2024-09-07', main: [9, 15, 31, 43, 48], bonus: [9] },
    { date: '2024-09-09', main: [3, 8, 17, 18, 41], bonus: [3] },
    { date: '2024-09-11', main: [10, 24, 28, 30, 39], bonus: [5] },
    { date: '2024-09-13', main: [18, 19, 23, 40, 45], bonus: [9] },
    { date: '2024-09-14', main: [6, 11, 15, 32, 49], bonus: [4] },
    { date: '2024-09-16', main: [17, 27, 30, 31, 48], bonus: [8] },
    { date: '2024-09-18', main: [2, 23, 42, 44, 47], bonus: [5] },
    { date: '2024-09-21', main: [2, 4, 19, 30, 32], bonus: [9] },
    { date: '2024-09-23', main: [7, 9, 27, 28, 40], bonus: [6] },
    { date: '2024-09-25', main: [1, 5, 6, 10, 25], bonus: [9] },
    { date: '2024-09-28', main: [4, 39, 42, 45, 47], bonus: [1] },
    { date: '2024-09-30', main: [1, 17, 24, 33, 49], bonus: [9] },
    { date: '2024-10-02', main: [2, 4, 10, 12, 49], bonus: [9] },
    { date: '2024-10-05', main: [7, 13, 16, 30, 43], bonus: [6] },
    { date: '2024-10-07', main: [1, 5, 7, 26, 49], bonus: [8] },
    { date: '2024-10-09', main: [5, 22, 26, 31, 33], bonus: [7] },
    { date: '2024-10-12', main: [6, 33, 35, 37, 43], bonus: [6] },
    { date: '2024-10-14', main: [18, 20, 41, 42, 47], bonus: [2] },
    { date: '2024-10-16', main: [1, 21, 25, 35, 48], bonus: [3] },
    { date: '2024-10-19', main: [2, 10, 44, 45, 46], bonus: [5] },
    { date: '2024-10-21', main: [7, 11, 15, 19, 34], bonus: [7] },
    { date: '2024-10-23', main: [1, 27, 34, 40, 44], bonus: [2] },
    { date: '2024-10-26', main: [9, 11, 17, 20, 30], bonus: [8] },
    { date: '2024-10-28', main: [9, 21, 39, 41, 43], bonus: [3] },
    { date: '2024-10-30', main: [4, 8, 10, 29, 44], bonus: [1] },
    { date: '2024-10-31', main: [3, 9, 15, 18, 19], bonus: [9] },
    { date: '2024-11-02', main: [1, 21, 31, 43, 49], bonus: [6] },
    { date: '2024-11-04', main: [15, 16, 17, 35, 39], bonus: [2] },
    { date: '2024-11-06', main: [6, 8, 15, 23, 26], bonus: [5] },
    { date: '2024-11-09', main: [12, 23, 26, 35, 36], bonus: [8] },
    { date: '2024-11-11', main: [6, 8, 11, 35, 46], bonus: [6] },
    { date: '2024-11-13', main: [9, 12, 13, 32, 39], bonus: [10] },
    { date: '2024-11-16', main: [5, 7, 19, 29, 46], bonus: [4] },
    { date: '2024-11-18', main: [3, 6, 8, 12, 17], bonus: [9] },
    { date: '2024-11-20', main: [27, 35, 37, 45, 48], bonus: [5] },
    { date: '2024-11-23', main: [20, 33, 34, 36, 37], bonus: [2] },
    { date: '2024-11-25', main: [3, 7, 13, 37, 49], bonus: [5] },
    { date: '2024-11-27', main: [7, 15, 20, 31, 35], bonus: [6] },
    { date: '2024-11-30', main: [4, 10, 19, 21, 38], bonus: [1] },
    { date: '2024-12-02', main: [4, 16, 22, 41, 48], bonus: [10] },
    { date: '2024-12-04', main: [3, 7, 21, 34, 40], bonus: [1] },
    { date: '2024-12-07', main: [9, 21, 24, 28, 30], bonus: [9] },
    { date: '2024-12-09', main: [5, 6, 9, 25, 38], bonus: [6] },
    { date: '2024-12-11', main: [8, 19, 24, 28, 43], bonus: [6] },
    { date: '2024-12-13', main: [2, 4, 9, 27, 29], bonus: [4] },
    { date: '2024-12-14', main: [22, 24, 30, 40, 44], bonus: [7] },
    { date: '2024-12-16', main: [5, 6, 26, 36, 43], bonus: [3] },
    { date: '2024-12-18', main: [8, 14, 26, 27, 46], bonus: [2] },
    { date: '2024-12-21', main: [6, 16, 28, 36, 41], bonus: [8] },
    { date: '2024-12-23', main: [2, 13, 17, 22, 38], bonus: [7] },
    { date: '2024-12-24', main: [9, 19, 37, 40, 44], bonus: [5] },
    { date: '2024-12-25', main: [6, 13, 22, 44, 46], bonus: [8] },
    { date: '2024-12-28', main: [7, 13, 31, 37, 39], bonus: [6] },
    { date: '2024-12-30', main: [1, 13, 21, 29, 31], bonus: [10] },
    { date: '2024-12-31', main: [3, 5, 23, 24, 45], bonus: [8] },
    { date: '2025-01-01', main: [2, 8, 11, 21, 25], bonus: [4] },
    { date: '2025-01-04', main: [9, 17, 19, 20, 29], bonus: [2] },
    { date: '2025-01-06', main: [3, 8, 16, 31, 42], bonus: [7] },
    { date: '2025-01-08', main: [14, 24, 26, 34, 38], bonus: [8] },
    { date: '2025-01-11', main: [6, 20, 29, 41, 42], bonus: [9] },
    { date: '2025-01-13', main: [3, 7, 24, 31, 41], bonus: [2] },
    { date: '2025-01-15', main: [1, 22, 27, 28, 40], bonus: [2] },
    { date: '2025-01-18', main: [1, 4, 11, 33, 44], bonus: [7] },
    { date: '2025-01-20', main: [6, 19, 28, 36, 40], bonus: [2] },
    { date: '2025-01-22', main: [23, 29, 36, 38, 44], bonus: [9] },
    { date: '2025-01-25', main: [5, 19, 35, 44, 45], bonus: [8] },
    { date: '2025-01-27', main: [3, 10, 24, 39, 48], bonus: [3] },
    { date: '2025-01-29', main: [17, 19, 27, 29, 41], bonus: [2] },
    { date: '2025-02-01', main: [11, 30, 34, 36, 46], bonus: [5] },
    { date: '2025-02-03', main: [27, 29, 32, 44, 48], bonus: [8] },
    { date: '2025-02-05', main: [5, 8, 14, 24, 28], bonus: [9] },
    { date: '2025-02-08', main: [11, 26, 42, 43, 49], bonus: [8] },
    { date: '2025-02-10', main: [2, 12, 29, 39, 44], bonus: [6] },
    { date: '2025-02-12', main: [1, 23, 30, 37, 41], bonus: [5] },
    { date: '2025-02-14', main: [9, 10, 17, 45, 46], bonus: [3] },
    { date: '2025-02-15', main: [6, 13, 42, 48, 49], bonus: [3] },
    { date: '2025-02-17', main: [3, 14, 20, 34, 40], bonus: [6] },
    { date: '2025-02-19', main: [16, 23, 28, 32, 42], bonus: [5] },
    { date: '2025-02-22', main: [23, 25, 28, 30, 39], bonus: [7] },
    { date: '2025-02-24', main: [5, 13, 32, 38, 46], bonus: [5] },
    { date: '2025-02-26', main: [3, 11, 15, 17, 44], bonus: [9] },
    { date: '2025-03-01', main: [8, 9, 14, 28, 33], bonus: [4] },
    { date: '2025-03-03', main: [4, 6, 13, 28, 41], bonus: [1] },
    { date: '2025-03-05', main: [7, 26, 28, 30, 47], bonus: [4] },
    { date: '2025-03-08', main: [2, 3, 10, 11, 18], bonus: [2] },
    { date: '2025-03-10', main: [13, 15, 23, 24, 39], bonus: [1] },
    { date: '2025-03-12', main: [10, 16, 21, 24, 32], bonus: [7] },
    { date: '2025-03-15', main: [6, 21, 27, 31, 40], bonus: [7] },
    { date: '2025-03-17', main: [9, 16, 20, 26, 32], bonus: [7] },
    { date: '2025-03-19', main: [3, 12, 14, 15, 45], bonus: [3] },
    { date: '2025-03-22', main: [3, 20, 23, 36, 49], bonus: [6] },
    { date: '2025-03-24', main: [21, 29, 35, 46, 47], bonus: [1] },
    { date: '2025-03-26', main: [4, 11, 19, 21, 41], bonus: [7] },
    { date: '2025-03-29', main: [7, 12, 14, 31, 41], bonus: [5] },
    { date: '2025-03-31', main: [3, 4, 16, 28, 38], bonus: [4] },
    { date: '2025-04-02', main: [4, 5, 15, 34, 45], bonus: [9] },
    { date: '2025-04-05', main: [8, 14, 22, 27, 30], bonus: [7] },
    { date: '2025-04-07', main: [2, 13, 21, 34, 38], bonus: [1] },
    { date: '2025-04-09', main: [12, 16, 36, 46, 47], bonus: [9] },
    { date: '2025-04-12', main: [3, 10, 13, 18, 47], bonus: [1] },
    { date: '2025-04-14', main: [25, 31, 33, 37, 40], bonus: [9] },
    { date: '2025-04-16', main: [13, 27, 38, 39, 40], bonus: [10] },
    { date: '2025-04-19', main: [11, 16, 19, 20, 32], bonus: [6] },
    { date: '2025-04-21', main: [5, 8, 13, 30, 48], bonus: [5] },
    { date: '2025-04-23', main: [3, 5, 15, 20, 35], bonus: [8] },
    { date: '2025-04-26', main: [3, 15, 23, 39, 45], bonus: [9] },
    { date: '2025-04-28', main: [3, 6, 14, 35, 36], bonus: [2] },
    { date: '2025-04-30', main: [3, 5, 8, 31, 42], bonus: [8] },
    { date: '2025-05-03', main: [19, 37, 38, 39, 42], bonus: [5] },
    { date: '2025-05-05', main: [8, 9, 34, 38, 47], bonus: [3] },
    { date: '2025-05-07', main: [1, 32, 36, 41, 46], bonus: [9] },
    { date: '2025-05-10', main: [12, 13, 29, 42, 49], bonus: [9] },
    { date: '2025-05-12', main: [2, 6, 12, 16, 24], bonus: [4] },
    { date: '2025-05-14', main: [12, 31, 34, 42, 43], bonus: [10] },
    { date: '2025-05-17', main: [9, 12, 13, 14, 18], bonus: [3] },
    { date: '2025-05-19', main: [8, 30, 33, 42, 43], bonus: [4] },
    { date: '2025-05-21', main: [7, 10, 11, 18, 49], bonus: [3] },
    { date: '2025-05-24', main: [14, 32, 39, 45, 49], bonus: [9] },
    { date: '2025-05-26', main: [24, 33, 36, 41, 45], bonus: [7] },
    { date: '2025-05-28', main: [4, 25, 26, 32, 38], bonus: [4] },
    { date: '2025-05-31', main: [4, 11, 27, 37, 39], bonus: [3] },
    { date: '2025-06-02', main: [8, 13, 25, 29, 36], bonus: [2] },
    { date: '2025-06-04', main: [2, 18, 38, 41, 45], bonus: [8] },
    { date: '2025-06-07', main: [7, 30, 37, 40, 45], bonus: [1] },
    { date: '2025-06-09', main: [5, 12, 25, 34, 38], bonus: [10] },
    { date: '2025-06-11', main: [7, 9, 15, 18, 19], bonus: [6] },
    { date: '2025-06-13', main: [8, 19, 28, 39, 42], bonus: [9] },
    { date: '2025-06-14', main: [16, 21, 25, 31, 44], bonus: [8] },
    { date: '2025-06-16', main: [1, 2, 4, 13, 39], bonus: [1] },
    { date: '2025-06-18', main: [9, 13, 19, 24, 36], bonus: [3] },
    { date: '2025-06-21', main: [18, 20, 25, 34, 49], bonus: [2] },
    { date: '2025-06-23', main: [20, 25, 38, 42, 44], bonus: [10] },
    { date: '2025-06-25', main: [2, 5, 26, 32, 44], bonus: [10] },
    { date: '2025-06-28', main: [2, 3, 4, 20, 28], bonus: [6] },
    { date: '2025-06-30', main: [8, 10, 12, 17, 18], bonus: [4] },
    { date: '2025-07-02', main: [19, 25, 29, 30, 38], bonus: [10] },
    { date: '2025-07-04', main: [9, 19, 21, 35, 49], bonus: [10] },
    { date: '2025-07-05', main: [25, 32, 37, 42, 46], bonus: [10] },
    { date: '2025-07-07', main: [3, 18, 26, 27, 41], bonus: [6] },
    { date: '2025-07-09', main: [1, 22, 25, 36, 45], bonus: [4] },
    { date: '2025-07-12', main: [13, 36, 39, 48, 49], bonus: [7] },
    { date: '2025-07-14', main: [6, 20, 27, 28, 37], bonus: [3] },
    { date: '2025-07-16', main: [3, 34, 36, 41, 45], bonus: [4] },
    { date: '2025-07-19', main: [18, 19, 24, 25, 45], bonus: [1] },
    { date: '2025-07-21', main: [5, 9, 16, 26, 33], bonus: [8] },
    { date: '2025-07-23', main: [5, 18, 29, 30, 43], bonus: [2] },
    { date: '2025-07-26', main: [1, 9, 19, 32, 44], bonus: [3] },
    { date: '2025-07-28', main: [6, 22, 25, 27, 30], bonus: [5] },
    { date: '2025-07-30', main: [3, 13, 20, 37, 41], bonus: [3] },
    { date: '2025-08-02', main: [14, 15, 22, 31, 48], bonus: [2] },
    { date: '2025-08-04', main: [6, 10, 31, 34, 43], bonus: [5] },
    { date: '2025-08-06', main: [5, 18, 19, 23, 49], bonus: [8] },
    { date: '2025-08-09', main: [6, 15, 19, 21, 38], bonus: [8] },
    { date: '2025-08-11', main: [1, 10, 30, 40, 44], bonus: [2] },
    { date: '2025-08-13', main: [9, 31, 36, 42, 47], bonus: [1] },
    { date: '2025-08-16', main: [4, 5, 18, 31, 45], bonus: [7] },
    { date: '2025-08-18', main: [2, 8, 21, 26, 27], bonus: [6] },
    { date: '2025-08-20', main: [1, 2, 27, 36, 40], bonus: [7] },
    { date: '2025-08-23', main: [15, 20, 23, 30, 49], bonus: [9] },
    { date: '2025-08-25', main: [14, 21, 22, 32, 42], bonus: [2] },
    { date: '2025-08-27', main: [7, 12, 20, 31, 40], bonus: [6] },
    { date: '2025-08-30', main: [4, 15, 23, 34, 39], bonus: [10] },
    { date: '2025-09-01', main: [4, 25, 33, 38, 44], bonus: [4] },
    { date: '2025-09-03', main: [2, 24, 30, 31, 36], bonus: [5] },
    { date: '2025-09-06', main: [4, 17, 18, 21, 26], bonus: [1] },
    { date: '2025-09-08', main: [10, 21, 22, 30, 42], bonus: [8] },
    { date: '2025-09-10', main: [14, 17, 18, 24, 49], bonus: [7] },
    { date: '2025-09-13', main: [6, 28, 29, 31, 41], bonus: [10] },
    { date: '2025-09-15', main: [2, 10, 17, 30, 32], bonus: [5] },
    { date: '2025-09-17', main: [2, 25, 32, 37, 47], bonus: [3] },
    { date: '2025-09-19', main: [4, 28, 30, 37, 44], bonus: [4] },
    { date: '2025-09-20', main: [10, 18, 36, 39, 47], bonus: [7] },
    { date: '2025-09-22', main: [5, 10, 29, 41, 47], bonus: [4] },
    { date: '2025-09-24', main: [3, 21, 23, 31, 32], bonus: [4] },
    { date: '2025-09-27', main: [3, 11, 19, 45, 46], bonus: [4] },
    { date: '2025-09-29', main: [5, 17, 27, 32, 44], bonus: [4] },
    { date: '2025-10-01', main: [5, 10, 35, 41, 44], bonus: [7] },
    { date: '2025-10-04', main: [4, 6, 29, 31, 45], bonus: [8] },
    { date: '2025-10-06', main: [1, 10, 22, 26, 30], bonus: [9] },
    { date: '2025-10-08', main: [5, 10, 25, 39, 47], bonus: [7] },
    { date: '2025-10-11', main: [3, 5, 12, 32, 40], bonus: [4] },
    { date: '2025-10-13', main: [2, 11, 36, 45, 49], bonus: [7] },
    { date: '2025-10-15', main: [1, 9, 17, 22, 48], bonus: [5] },
    { date: '2025-10-18', main: [11, 17, 19, 47, 49], bonus: [1] },
    { date: '2025-10-20', main: [12, 24, 34, 38, 43], bonus: [1] },
    { date: '2025-10-22', main: [4, 29, 31, 39, 49], bonus: [1] },
    { date: '2025-10-25', main: [4, 5, 6, 16, 35], bonus: [1] },
    { date: '2025-10-27', main: [10, 23, 45, 47, 48], bonus: [8] },
    { date: '2025-10-29', main: [6, 7, 34, 35, 45], bonus: [8] },
    { date: '2025-10-31', main: [10, 24, 26, 36, 40], bonus: [10] },
    { date: '2025-11-01', main: [3, 17, 24, 26, 33], bonus: [6] },
    { date: '2025-11-03', main: [2, 3, 29, 32, 49], bonus: [2] },
    { date: '2025-11-05', main: [19, 23, 29, 31, 45], bonus: [4] },
    { date: '2025-11-08', main: [16, 27, 32, 36, 48], bonus: [8] },
    { date: '2025-11-10', main: [8, 9, 16, 37, 45], bonus: [2] },
    { date: '2025-11-12', main: [3, 8, 29, 33, 37], bonus: [2] },
    { date: '2025-11-15', main: [5, 11, 22, 23, 24], bonus: [3] },
    { date: '2025-11-17', main: [7, 17, 26, 28, 45], bonus: [6] },
    { date: '2025-11-19', main: [24, 26, 33, 45, 46], bonus: [2] },
    { date: '2025-11-22', main: [7, 10, 34, 40, 45], bonus: [6] },
    { date: '2025-11-24', main: [22, 28, 29, 36, 47], bonus: [1] },
    { date: '2025-11-26', main: [9, 14, 16, 26, 33], bonus: [5] },
    { date: '2025-11-29', main: [8, 13, 20, 23, 27], bonus: [3] },
    { date: '2025-12-01', main: [11, 13, 14, 38, 46], bonus: [1] },
    { date: '2025-12-03', main: [10, 13, 18, 28, 36], bonus: [8] },
    { date: '2025-12-06', main: [2, 14, 24, 33, 34], bonus: [1] },
    { date: '2025-12-08', main: [8, 9, 11, 17, 41], bonus: [1] },
    { date: '2025-12-10', main: [33, 34, 35, 39, 44], bonus: [10] },
    { date: '2025-12-13', main: [7, 10, 15, 22, 25], bonus: [7] },
    { date: '2025-12-15', main: [26, 32, 38, 42, 43], bonus: [6] },
    { date: '2025-12-17', main: [2, 14, 20, 30, 49], bonus: [2] },
    { date: '2025-12-20', main: [16, 28, 37, 42, 47], bonus: [2] },
    { date: '2025-12-22', main: [16, 20, 40, 41, 49], bonus: [9] },
    { date: '2025-12-24', main: [5, 9, 33, 42, 45], bonus: [1] },
    { date: '2025-12-25', main: [2, 3, 30, 35, 44], bonus: [10] },
    { date: '2025-12-27', main: [16, 17, 41, 42, 49], bonus: [10] },
    { date: '2025-12-29', main: [10, 21, 33, 43, 47], bonus: [3] },
    { date: '2025-12-31', main: [6, 15, 19, 39, 43], bonus: [1] },
    { date: '2026-01-03', main: [9, 29, 30, 31, 40], bonus: [2] },
    { date: '2026-01-05', main: [5, 13, 23, 30, 31], bonus: [6] },
    { date: '2026-01-07', main: [5, 17, 30, 35, 36], bonus: [3] },
    { date: '2026-01-10', main: [1, 7, 16, 35, 36], bonus: [3] },
    { date: '2026-01-12', main: [2, 13, 24, 32, 39], bonus: [6] },
    { date: '2026-01-14', main: [4, 5, 23, 28, 31], bonus: [5] },
    { date: '2026-01-17', main: [12, 26, 34, 42, 49], bonus: [6] },
    { date: '2026-01-19', main: [12, 13, 16, 24, 34], bonus: [4] },
    { date: '2026-01-21', main: [25, 27, 29, 40, 45], bonus: [10] },
    { date: '2026-01-24', main: [10, 18, 30, 33, 39], bonus: [8] },
    { date: '2026-01-26', main: [9, 25, 28, 32, 36], bonus: [4] },
    { date: '2026-01-28', main: [7, 10, 11, 30, 42], bonus: [4] },
    { date: '2026-01-31', main: [1, 4, 14, 21, 24], bonus: [4] },
    { date: '2026-02-02', main: [7, 11, 12, 29, 41], bonus: [5] },
    { date: '2026-02-04', main: [1, 11, 12, 24, 37], bonus: [9] },
    { date: '2026-02-07', main: [2, 9, 20, 41, 49], bonus: [9] },
    { date: '2026-02-09', main: [22, 23, 25, 38, 42], bonus: [3] },
    { date: '2026-02-11', main: [3, 32, 36, 44, 47], bonus: [8] },
    { date: '2026-02-13', main: [5, 20, 26, 34, 39], bonus: [3] },
    { date: '2026-02-14', main: [9, 14, 17, 27, 33], bonus: [6] },
    { date: '2026-02-16', main: [8, 17, 21, 29, 35], bonus: [3] },
    { date: '2026-02-18', main: [4, 16, 22, 25, 36], bonus: [7] },
    { date: '2026-02-21', main: [4, 14, 17, 32, 44], bonus: [9] },
    { date: '2026-02-23', main: [15, 20, 29, 41, 47], bonus: [4] },
    { date: '2026-02-25', main: [8, 9, 22, 26, 30], bonus: [8] },
    { date: '2026-02-28', main: [18, 24, 31, 40, 49], bonus: [2] },
    { date: '2026-03-02', main: [19, 20, 34, 37, 40], bonus: [6] },
    { date: '2026-03-04', main: [14, 16, 40, 46, 47], bonus: [4] },
    { date: '2026-03-07', main: [9, 10, 11, 21, 22], bonus: [9] },
    { date: '2026-03-09', main: [5, 12, 16, 24, 35], bonus: [4] },
    { date: '2026-03-11', main: [10, 12, 14, 16, 18], bonus: [3] },
    { date: '2026-03-13', main: [16, 17, 40, 48, 49], bonus: [5] },
    { date: '2026-03-14', main: [10, 22, 23, 25, 46], bonus: [3] },
    { date: '2026-03-16', main: [5, 14, 25, 31, 42], bonus: [4] },
    { date: '2026-03-18', main: [8, 13, 18, 45, 48], bonus: [7] },
    { date: '2026-03-21', main: [3, 19, 24, 33, 45], bonus: [10] },
    { date: '2026-03-23', main: [3, 9, 30, 38, 42], bonus: [4] },
    { date: '2026-03-25', main: [19, 28, 30, 35, 48], bonus: [5] },
    { date: '2026-03-28', main: [17, 28, 30, 38, 45], bonus: [6] },
    { date: '2026-03-30', main: [8, 10, 28, 29, 47], bonus: [5] },
    { date: '2026-04-01', main: [3, 23, 34, 43, 47], bonus: [5] },
    { date: '2026-04-04', main: [5, 6, 7, 21, 36], bonus: [6] },
    { date: '2026-04-06', main: [3, 19, 23, 29, 33], bonus: [3] },
    { date: '2026-04-08', main: [13, 16, 23, 26, 46], bonus: [1] },
    { date: '2026-04-11', main: [7, 39, 41, 45, 48], bonus: [9] },
    { date: '2026-04-13', main: [4, 10, 16, 18, 22], bonus: [4] },
    { date: '2026-04-15', main: [2, 21, 44, 47, 48], bonus: [10] },
    { date: '2026-04-18', main: [5, 22, 23, 24, 25], bonus: [10] },
    { date: '2026-04-20', main: [2, 12, 21, 29, 33], bonus: [6] },
    { date: '2026-04-22', main: [30, 37, 38, 40, 43], bonus: [1] },
    { date: '2026-04-24', main: [2, 12, 16, 20, 26], bonus: [2] },
    { date: '2026-04-25', main: [9, 17, 22, 25, 49], bonus: [3] },
    { date: '2026-04-27', main: [6, 15, 23, 27, 43], bonus: [4] },
    { date: '2026-04-29', main: [2, 3, 30, 31, 37], bonus: [8] },
    { date: '2026-05-02', main: [10, 17, 19, 29, 41], bonus: [7] },
    { date: '2026-05-04', main: [4, 8, 15, 18, 46], bonus: [2] },
    { date: '2026-05-06', main: [7, 18, 27, 35, 48], bonus: [5] },
    { date: '2026-05-09', main: [16, 21, 25, 26, 31], bonus: [1] },
    { date: '2026-05-11', main: [17, 18, 30, 34, 39], bonus: [9] },
    { date: '2026-05-13', main: [17, 35, 38, 41, 46], bonus: [2] },
    { date: '2026-05-16', main: [1, 12, 30, 32, 34], bonus: [4] },
    { date: '2026-05-18', main: [14, 32, 33, 36, 49], bonus: [3] },
    { date: '2026-05-20', main: [8, 15, 28, 30, 48], bonus: [7] },
    { date: '2026-05-23', main: [20, 21, 23, 36, 38], bonus: [2] },
    { date: '2026-05-25', main: [19, 22, 27, 31, 49], bonus: [3] },
    { date: '2026-05-27', main: [3, 4, 15, 17, 41], bonus: [4] },
    { date: '2026-05-30', main: [3, 10, 31, 34, 47], bonus: [5] },
    { date: '2026-06-01', main: [5, 19, 26, 30, 33], bonus: [2] },
    { date: '2026-06-03', main: [4, 16, 17, 18, 30], bonus: [1] },
    { date: '2026-06-06', main: [13, 19, 24, 32, 43], bonus: [2] },
    { date: '2026-06-08', main: [24, 39, 41, 43, 48], bonus: [3] },
    { date: '2026-06-10', main: [2, 12, 14, 38, 47], bonus: [5] },
    { date: '2026-06-13', main: [11, 27, 28, 39, 41], bonus: [3] },
    { date: '2026-06-15', main: [23, 25, 29, 46, 49], bonus: [1] },
    { date: '2026-06-17', main: [1, 15, 32, 37, 39], bonus: [1] },
    { date: '2026-06-20', main: [5, 16, 31, 37, 41], bonus: [5] },
    { date: '2026-06-22', main: [7, 13, 30, 31, 47], bonus: [7] },
    { date: '2026-06-24', main: [8, 26, 29, 32, 38], bonus: [7] },
    { date: '2026-06-27', main: [18, 21, 24, 35, 36], bonus: [3] },
    { date: '2026-06-29', main: [1, 13, 27, 32, 41], bonus: [2] },
    { date: '2026-07-01', main: [8, 9, 10, 25, 31], bonus: [5] },
    { date: '2026-07-04', main: [15, 31, 41, 48, 49], bonus: [3] },
    { date: '2026-07-06', main: [16, 29, 31, 36, 46], bonus: [7] },
    { date: '2026-07-08', main: [7, 16, 18, 28, 35], bonus: [8] },
    { date: '2026-07-11', main: [3, 16, 34, 35, 38], bonus: [2] },
    { date: '2026-07-13', main: [5, 18, 26, 29, 45], bonus: [7] },
    { date: '2026-07-15', main: [1, 9, 13, 21, 37], bonus: [3] },
    { date: '2026-07-18', main: [10, 11, 24, 27, 36], bonus: [7] },
    { date: '2026-07-20', main: [13, 15, 20, 24, 45], bonus: [8] },
    { date: '2026-07-22', main: [4, 9, 10, 13, 23], bonus: [7] },
    { date: '2026-07-25', main: [22, 29, 30, 36, 47], bonus: [2] },
    { date: '2026-07-27', main: [6, 7, 8, 16, 36], bonus: [3] },
    { date: '2026-07-29', main: [15, 27, 34, 40, 41], bonus: [9] },
    { date: '2026-08-01', main: [5, 6, 8, 30, 37], bonus: [4] },
    { date: '2026-08-03', main: [5, 25, 37, 41, 42], bonus: [10] },
    { date: '2026-08-05', main: [12, 22, 24, 33, 38], bonus: [9] },
    { date: '2026-08-08', main: [4, 6, 22, 36, 37], bonus: [3] },
    { date: '2026-08-10', main: [19, 21, 23, 34, 35], bonus: [10] },
    { date: '2026-08-12', main: [4, 5, 18, 22, 35], bonus: [2] },
    { date: '2026-08-15', main: [28, 31, 34, 38, 48], bonus: [3] },
    { date: '2026-08-17', main: [6, 7, 10, 15, 38], bonus: [5] },
    { date: '2026-08-19', main: [14, 18, 21, 26, 44], bonus: [7] },
    { date: '2026-08-22', main: [14, 17, 23, 38, 44], bonus: [5] },
    { date: '2026-08-24', main: [4, 22, 39, 46, 48], bonus: [10] },
    { date: '2026-08-26', main: [6, 13, 30, 32, 37], bonus: [9] },
    { date: '2026-08-29', main: [5, 7, 18, 40, 45], bonus: [2] },
    { date: '2026-08-31', main: [26, 32, 36, 39, 44], bonus: [2] },
    { date: '2026-09-02', main: [1, 10, 15, 32, 49], bonus: [5] },
  ],
  em: [
    { date: '2024-03-05', main: [2, 15, 17, 23, 36], bonus: [3, 8] },
    { date: '2024-03-08', main: [8, 11, 12, 16, 44], bonus: [4, 7] },
    { date: '2024-03-12', main: [13, 19, 30, 38, 46], bonus: [4, 12] },
    { date: '2024-03-15', main: [1, 4, 31, 34, 40], bonus: [4, 5] },
    { date: '2024-03-19', main: [7, 16, 18, 20, 32], bonus: [1, 3] },
    { date: '2024-03-22', main: [8, 11, 23, 32, 44], bonus: [9, 10] },
    { date: '2024-03-26', main: [2, 13, 14, 26, 29], bonus: [5, 6] },
    { date: '2024-03-29', main: [16, 17, 35, 36, 49], bonus: [1, 10] },
    { date: '2024-04-02', main: [1, 23, 31, 36, 48], bonus: [5, 8] },
    { date: '2024-04-05', main: [13, 18, 26, 35, 37], bonus: [8, 11] },
    { date: '2024-04-09', main: [19, 23, 26, 27, 46], bonus: [2, 10] },
    { date: '2024-04-12', main: [2, 3, 12, 16, 45], bonus: [2, 11] },
    { date: '2024-04-16', main: [22, 29, 31, 39, 46], bonus: [3, 7] },
    { date: '2024-04-19', main: [10, 20, 40, 44, 46], bonus: [1, 3] },
    { date: '2024-04-23', main: [6, 9, 11, 32, 49], bonus: [2, 10] },
    { date: '2024-04-26', main: [2, 20, 39, 40, 47], bonus: [4, 8] },
    { date: '2024-04-30', main: [13, 22, 24, 33, 47], bonus: [1, 5] },
    { date: '2024-05-03', main: [6, 9, 10, 30, 49], bonus: [3, 4] },
    { date: '2024-05-07', main: [35, 36, 41, 42, 45], bonus: [6, 11] },
    { date: '2024-05-10', main: [13, 28, 29, 44, 48], bonus: [4, 12] },
    { date: '2024-05-14', main: [2, 8, 17, 28, 35], bonus: [7, 9] },
    { date: '2024-05-17', main: [18, 31, 32, 41, 46], bonus: [1, 10] },
    { date: '2024-05-21', main: [11, 13, 14, 34, 48], bonus: [7, 9] },
    { date: '2024-05-24', main: [9, 12, 18, 22, 50], bonus: [1, 3] },
    { date: '2024-05-28', main: [16, 18, 35, 36, 41], bonus: [6, 7] },
    { date: '2024-05-31', main: [4, 7, 16, 33, 34], bonus: [7, 8] },
    { date: '2024-06-04', main: [6, 7, 9, 14, 43], bonus: [3, 4] },
    { date: '2024-06-07', main: [15, 16, 26, 30, 37], bonus: [5, 8] },
    { date: '2024-06-11', main: [7, 15, 34, 45, 48], bonus: [7, 9] },
    { date: '2024-06-14', main: [2, 13, 16, 24, 32], bonus: [1, 7] },
    { date: '2024-06-18', main: [3, 11, 33, 34, 36], bonus: [1, 12] },
    { date: '2024-06-21', main: [3, 4, 7, 11, 17], bonus: [3, 12] },
    { date: '2024-06-25', main: [14, 16, 37, 45, 49], bonus: [5, 7] },
    { date: '2024-06-28', main: [10, 16, 18, 22, 35], bonus: [1, 10] },
    { date: '2024-07-02', main: [2, 7, 34, 35, 46], bonus: [6, 8] },
    { date: '2024-07-05', main: [11, 13, 29, 31, 47], bonus: [1, 11] },
    { date: '2024-07-09', main: [6, 15, 19, 28, 39], bonus: [7, 11] },
    { date: '2024-07-12', main: [12, 18, 24, 25, 39], bonus: [8, 10] },
    { date: '2024-07-16', main: [2, 32, 35, 36, 39], bonus: [7, 8] },
    { date: '2024-07-19', main: [15, 22, 35, 44, 48], bonus: [6, 7] },
    { date: '2024-07-23', main: [4, 8, 10, 16, 34], bonus: [4, 8] },
    { date: '2024-07-26', main: [4, 19, 23, 35, 37], bonus: [4, 8] },
    { date: '2024-07-30', main: [9, 25, 28, 37, 38], bonus: [2, 8] },
    { date: '2024-08-02', main: [5, 7, 12, 33, 46], bonus: [3, 12] },
    { date: '2024-08-06', main: [1, 18, 27, 41, 50], bonus: [2, 12] },
    { date: '2024-08-09', main: [21, 23, 25, 33, 44], bonus: [4, 10] },
    { date: '2024-08-13', main: [15, 16, 39, 40, 47], bonus: [1, 6] },
    { date: '2024-08-16', main: [15, 17, 29, 45, 49], bonus: [1, 10] },
    { date: '2024-08-20', main: [7, 10, 13, 18, 26], bonus: [3, 12] },
    { date: '2024-08-23', main: [9, 15, 24, 47, 50], bonus: [8, 9] },
    { date: '2024-08-27', main: [1, 8, 11, 42, 47], bonus: [4, 11] },
    { date: '2024-08-30', main: [3, 24, 27, 33, 42], bonus: [4, 6] },
    { date: '2024-09-03', main: [7, 9, 11, 16, 45], bonus: [2, 5] },
    { date: '2024-09-06', main: [12, 14, 34, 41, 47], bonus: [3, 4] },
    { date: '2024-09-10', main: [6, 29, 46, 47, 48], bonus: [2, 9] },
    { date: '2024-09-13', main: [10, 15, 17, 31, 42], bonus: [4, 12] },
    { date: '2024-09-17', main: [20, 30, 32, 41, 44], bonus: [1, 10] },
    { date: '2024-09-20', main: [16, 25, 29, 34, 37], bonus: [3, 7] },
    { date: '2024-09-24', main: [18, 20, 21, 36, 49], bonus: [3, 5] },
    { date: '2024-09-27', main: [7, 20, 21, 27, 38], bonus: [5, 12] },
    { date: '2024-10-01', main: [8, 22, 29, 41, 42], bonus: [9, 11] },
    { date: '2024-10-04', main: [4, 8, 16, 17, 20], bonus: [1, 6] },
    { date: '2024-10-08', main: [7, 14, 19, 34, 40], bonus: [6, 8] },
    { date: '2024-10-11', main: [16, 23, 32, 46, 49], bonus: [4, 5] },
    { date: '2024-10-15', main: [2, 15, 32, 36, 48], bonus: [3, 9] },
    { date: '2024-10-18', main: [4, 15, 23, 30, 39], bonus: [1, 12] },
    { date: '2024-10-22', main: [3, 13, 27, 30, 46], bonus: [1, 2] },
    { date: '2024-10-25', main: [4, 17, 20, 25, 45], bonus: [8, 9] },
    { date: '2024-10-29', main: [1, 2, 19, 30, 45], bonus: [10, 12] },
    { date: '2024-11-01', main: [7, 33, 38, 44, 50], bonus: [2, 7] },
    { date: '2024-11-05', main: [1, 8, 19, 37, 50], bonus: [6, 9] },
    { date: '2024-11-08', main: [2, 33, 35, 42, 48], bonus: [1, 3] },
    { date: '2024-11-12', main: [10, 11, 12, 22, 50], bonus: [1, 10] },
    { date: '2024-11-15', main: [7, 8, 34, 39, 44], bonus: [2, 6] },
    { date: '2024-11-19', main: [4, 13, 20, 28, 49], bonus: [7, 12] },
    { date: '2024-11-22', main: [10, 11, 12, 29, 31], bonus: [8, 11] },
    { date: '2024-11-26', main: [7, 11, 25, 31, 40], bonus: [9, 12] },
    { date: '2024-11-29', main: [8, 17, 18, 29, 43], bonus: [5, 9] },
    { date: '2024-12-03', main: [23, 25, 34, 46, 47], bonus: [6, 8] },
    { date: '2024-12-06', main: [14, 25, 39, 44, 47], bonus: [6, 10] },
    { date: '2024-12-10', main: [5, 24, 25, 29, 47], bonus: [5, 9] },
    { date: '2024-12-13', main: [1, 15, 25, 42, 50], bonus: [4, 10] },
    { date: '2024-12-17', main: [1, 3, 4, 21, 29], bonus: [2, 7] },
    { date: '2024-12-20', main: [10, 14, 21, 33, 50], bonus: [6, 9] },
    { date: '2024-12-24', main: [6, 10, 16, 23, 24], bonus: [11, 12] },
    { date: '2024-12-27', main: [12, 22, 27, 33, 45], bonus: [4, 8] },
    { date: '2024-12-31', main: [19, 24, 26, 28, 33], bonus: [8, 12] },
    { date: '2025-01-03', main: [3, 19, 29, 35, 37], bonus: [1, 9] },
    { date: '2025-01-07', main: [20, 33, 35, 41, 47], bonus: [4, 12] },
    { date: '2025-01-10', main: [12, 27, 36, 37, 42], bonus: [6, 7] },
    { date: '2025-01-14', main: [18, 20, 29, 41, 48], bonus: [5, 9] },
    { date: '2025-01-17', main: [8, 15, 24, 35, 42], bonus: [6, 8] },
    { date: '2025-01-21', main: [6, 8, 14, 27, 41], bonus: [4, 5] },
    { date: '2025-01-24', main: [2, 11, 19, 30, 49], bonus: [3, 8] },
    { date: '2025-01-28', main: [9, 37, 41, 42, 49], bonus: [1, 9] },
    { date: '2025-01-31', main: [22, 30, 41, 44, 49], bonus: [2, 7] },
    { date: '2025-02-04', main: [3, 4, 29, 39, 43], bonus: [5, 10] },
    { date: '2025-02-07', main: [10, 23, 24, 29, 45], bonus: [8, 10] },
    { date: '2025-02-11', main: [3, 21, 36, 41, 46], bonus: [1, 6] },
    { date: '2025-02-14', main: [4, 14, 31, 36, 38], bonus: [3, 10] },
    { date: '2025-02-18', main: [5, 14, 25, 26, 40], bonus: [5, 7] },
    { date: '2025-02-21', main: [1, 3, 11, 20, 43], bonus: [2, 11] },
    { date: '2025-02-25', main: [17, 22, 23, 24, 44], bonus: [6, 11] },
    { date: '2025-02-28', main: [7, 16, 31, 43, 46], bonus: [5, 9] },
    { date: '2025-03-04', main: [15, 20, 29, 35, 42], bonus: [2, 9] },
    { date: '2025-03-07', main: [6, 10, 27, 32, 48], bonus: [3, 8] },
    { date: '2025-03-11', main: [13, 36, 37, 42, 47], bonus: [7, 11] },
    { date: '2025-03-14', main: [8, 10, 33, 35, 49], bonus: [2, 9] },
    { date: '2025-03-18', main: [4, 9, 35, 46, 50], bonus: [8, 11] },
    { date: '2025-03-21', main: [9, 17, 18, 21, 50], bonus: [5, 12] },
    { date: '2025-03-25', main: [1, 3, 18, 33, 36], bonus: [2, 6] },
    { date: '2025-03-28', main: [10, 21, 30, 42, 45], bonus: [1, 9] },
    { date: '2025-04-01', main: [9, 24, 30, 46, 49], bonus: [4, 12] },
    { date: '2025-04-04', main: [27, 39, 41, 45, 50], bonus: [5, 7] },
    { date: '2025-04-08', main: [3, 14, 15, 48, 49], bonus: [1, 7] },
    { date: '2025-04-11', main: [14, 28, 34, 46, 49], bonus: [3, 8] },
    { date: '2025-04-15', main: [3, 31, 33, 38, 44], bonus: [6, 12] },
    { date: '2025-04-18', main: [20, 27, 35, 39, 48], bonus: [3, 8] },
    { date: '2025-04-22', main: [7, 28, 33, 37, 47], bonus: [9, 12] },
    { date: '2025-04-25', main: [13, 22, 32, 39, 41], bonus: [1, 12] },
    { date: '2025-04-29', main: [2, 9, 24, 30, 41], bonus: [1, 11] },
    { date: '2025-05-02', main: [3, 5, 19, 21, 49], bonus: [1, 10] },
    { date: '2025-05-06', main: [8, 23, 24, 47, 48], bonus: [4, 9] },
    { date: '2025-05-09', main: [15, 18, 25, 29, 47], bonus: [5, 9] },
    { date: '2025-05-13', main: [9, 19, 44, 47, 50], bonus: [2, 9] },
    { date: '2025-05-16', main: [6, 9, 25, 37, 46], bonus: [6, 12] },
    { date: '2025-05-20', main: [1, 8, 13, 29, 47], bonus: [5, 6] },
    { date: '2025-05-23', main: [10, 29, 43, 46, 49], bonus: [7, 12] },
    { date: '2025-05-27', main: [12, 30, 38, 40, 41], bonus: [4, 12] },
    { date: '2025-05-30', main: [4, 7, 14, 33, 36], bonus: [1, 5] },
    { date: '2025-06-03', main: [12, 15, 38, 47, 48], bonus: [5, 7] },
    { date: '2025-06-06', main: [20, 21, 29, 30, 35], bonus: [2, 12] },
    { date: '2025-06-10', main: [19, 36, 39, 40, 45], bonus: [5, 6] },
    { date: '2025-06-13', main: [2, 28, 40, 43, 45], bonus: [3, 7] },
    { date: '2025-06-17', main: [13, 22, 23, 44, 49], bonus: [3, 5] },
    { date: '2025-06-20', main: [5, 8, 24, 37, 47], bonus: [3, 9] },
    { date: '2025-06-24', main: [7, 16, 21, 23, 39], bonus: [7, 11] },
    { date: '2025-06-27', main: [19, 27, 36, 45, 49], bonus: [7, 10] },
    { date: '2025-07-01', main: [1, 17, 28, 32, 34], bonus: [7, 8] },
    { date: '2025-07-04', main: [19, 29, 42, 45, 48], bonus: [5, 7] },
    { date: '2025-07-08', main: [1, 8, 9, 18, 50], bonus: [1, 5] },
    { date: '2025-07-11', main: [8, 23, 24, 45, 49], bonus: [2, 10] },
    { date: '2025-07-15', main: [24, 38, 41, 45, 49], bonus: [1, 6] },
    { date: '2025-07-18', main: [13, 19, 25, 42, 45], bonus: [2, 9] },
    { date: '2025-07-22', main: [8, 15, 26, 33, 41], bonus: [9, 10] },
    { date: '2025-07-25', main: [6, 7, 23, 32, 36], bonus: [11, 12] },
    { date: '2025-07-29', main: [5, 6, 42, 44, 46], bonus: [4, 8] },
    { date: '2025-08-01', main: [4, 16, 25, 29, 30], bonus: [2, 10] },
    { date: '2025-08-05', main: [1, 3, 5, 42, 47], bonus: [5, 10] },
    { date: '2025-08-08', main: [2, 12, 19, 34, 44], bonus: [6, 10] },
    { date: '2025-08-12', main: [18, 28, 42, 46, 48], bonus: [3, 9] },
    { date: '2025-08-15', main: [13, 30, 35, 36, 40], bonus: [2, 6] },
    { date: '2025-08-19', main: [24, 31, 34, 41, 43], bonus: [6, 8] },
    { date: '2025-08-22', main: [6, 9, 12, 30, 39], bonus: [4, 10] },
    { date: '2025-08-26', main: [2, 14, 38, 42, 45], bonus: [10, 11] },
    { date: '2025-08-29', main: [6, 9, 10, 13, 37], bonus: [1, 7] },
    { date: '2025-09-02', main: [13, 30, 31, 32, 36], bonus: [1, 12] },
    { date: '2025-09-05', main: [27, 30, 31, 41, 43], bonus: [5, 8] },
    { date: '2025-09-09', main: [3, 13, 24, 39, 40], bonus: [2, 8] },
    { date: '2025-09-12', main: [5, 10, 23, 31, 37], bonus: [3, 11] },
    { date: '2025-09-16', main: [1, 9, 13, 35, 40], bonus: [5, 6] },
    { date: '2025-09-19', main: [8, 10, 26, 32, 42], bonus: [9, 12] },
    { date: '2025-09-23', main: [11, 13, 24, 29, 33], bonus: [2, 5] },
    { date: '2025-09-26', main: [4, 17, 25, 28, 44], bonus: [5, 11] },
    { date: '2025-09-30', main: [3, 8, 15, 17, 48], bonus: [2, 8] },
    { date: '2025-10-03', main: [6, 12, 18, 25, 41], bonus: [2, 6] },
    { date: '2025-10-07', main: [24, 39, 42, 43, 48], bonus: [5, 8] },
    { date: '2025-10-10', main: [6, 7, 17, 20, 21], bonus: [1, 10] },
    { date: '2025-10-14', main: [5, 8, 14, 16, 18], bonus: [3, 10] },
    { date: '2025-10-17', main: [13, 35, 39, 44, 47], bonus: [3, 5] },
    { date: '2025-10-21', main: [5, 24, 29, 40, 42], bonus: [6, 12] },
    { date: '2025-10-24', main: [7, 8, 25, 31, 45], bonus: [7, 12] },
    { date: '2025-10-28', main: [7, 8, 24, 35, 49], bonus: [2, 12] },
    { date: '2025-10-31', main: [5, 14, 38, 43, 45], bonus: [7, 11] },
    { date: '2025-11-04', main: [6, 9, 25, 28, 45], bonus: [1, 4] },
    { date: '2025-11-07', main: [11, 21, 39, 40, 43], bonus: [2, 8] },
    { date: '2025-11-11', main: [4, 22, 32, 36, 47], bonus: [2, 10] },
    { date: '2025-11-14', main: [9, 26, 27, 45, 48], bonus: [8, 9] },
    { date: '2025-11-18', main: [2, 4, 15, 21, 48], bonus: [6, 12] },
    { date: '2025-11-21', main: [17, 19, 29, 35, 48], bonus: [5, 9] },
    { date: '2025-11-25', main: [6, 11, 17, 35, 44], bonus: [3, 7] },
    { date: '2025-11-28', main: [5, 29, 33, 39, 42], bonus: [3, 9] },
    { date: '2025-12-02', main: [4, 13, 14, 20, 41], bonus: [6, 12] },
    { date: '2025-12-05', main: [9, 15, 25, 34, 46], bonus: [8, 12] },
    { date: '2025-12-09', main: [2, 8, 13, 29, 49], bonus: [2, 11] },
    { date: '2025-12-12', main: [7, 25, 30, 37, 41], bonus: [5, 11] },
    { date: '2025-12-16', main: [14, 16, 40, 41, 44], bonus: [2, 10] },
    { date: '2025-12-19', main: [17, 21, 39, 43, 44], bonus: [1, 11] },
    { date: '2025-12-23', main: [8, 26, 27, 29, 44], bonus: [11, 12] },
    { date: '2025-12-26', main: [12, 22, 32, 36, 48], bonus: [3, 4] },
    { date: '2025-12-30', main: [11, 26, 29, 34, 44], bonus: [1, 10] },
    { date: '2026-01-02', main: [8, 27, 42, 44, 46], bonus: [1, 10] },
    { date: '2026-01-06', main: [5, 14, 17, 18, 31], bonus: [10, 12] },
    { date: '2026-01-09', main: [1, 7, 10, 26, 34], bonus: [2, 4] },
    { date: '2026-01-13', main: [6, 10, 18, 44, 47], bonus: [2, 10] },
    { date: '2026-01-16', main: [5, 17, 24, 29, 50], bonus: [5, 10] },
    { date: '2026-01-20', main: [11, 18, 19, 22, 50], bonus: [1, 11] },
    { date: '2026-01-23', main: [4, 5, 13, 21, 42], bonus: [3, 10] },
    { date: '2026-01-27', main: [4, 23, 42, 43, 47], bonus: [3, 9] },
    { date: '2026-01-30', main: [14, 18, 31, 35, 46], bonus: [7, 11] },
    { date: '2026-02-03', main: [26, 27, 28, 34, 37], bonus: [4, 9] },
    { date: '2026-02-06', main: [10, 13, 20, 23, 24], bonus: [6, 11] },
    { date: '2026-02-10', main: [1, 17, 19, 34, 42], bonus: [5, 8] },
    { date: '2026-02-13', main: [9, 13, 31, 37, 40], bonus: [6, 9] },
    { date: '2026-02-17', main: [1, 4, 6, 10, 41], bonus: [5, 12] },
    { date: '2026-02-20', main: [13, 24, 28, 33, 35], bonus: [5, 9] },
    { date: '2026-02-24', main: [10, 27, 40, 43, 47], bonus: [6, 10] },
    { date: '2026-02-27', main: [14, 24, 27, 39, 42], bonus: [6, 10] },
    { date: '2026-03-03', main: [6, 7, 24, 34, 50], bonus: [5, 7] },
    { date: '2026-03-06', main: [15, 16, 19, 28, 37], bonus: [6, 9] },
    { date: '2026-03-10', main: [12, 14, 27, 44, 50], bonus: [4, 12] },
    { date: '2026-03-13', main: [13, 17, 26, 41, 48], bonus: [4, 10] },
    { date: '2026-03-17', main: [5, 17, 28, 33, 41], bonus: [3, 9] },
    { date: '2026-03-20', main: [5, 12, 16, 37, 46], bonus: [8, 10] },
    { date: '2026-03-24', main: [12, 16, 17, 18, 27], bonus: [1, 3] },
    { date: '2026-03-27', main: [4, 10, 43, 44, 48], bonus: [2, 4] },
    { date: '2026-03-31', main: [5, 8, 10, 33, 38], bonus: [2, 7] },
    { date: '2026-04-03', main: [8, 27, 29, 46, 49], bonus: [2, 10] },
    { date: '2026-04-07', main: [11, 14, 19, 36, 49], bonus: [6, 7] },
    { date: '2026-04-10', main: [10, 13, 14, 38, 41], bonus: [6, 9] },
    { date: '2026-04-14', main: [1, 2, 4, 28, 44], bonus: [5, 12] },
    { date: '2026-04-17', main: [22, 23, 28, 41, 47], bonus: [6, 8] },
    { date: '2026-04-21', main: [13, 16, 29, 40, 47], bonus: [3, 4] },
    { date: '2026-04-24', main: [25, 26, 30, 40, 45], bonus: [1, 5] },
    { date: '2026-04-28', main: [26, 29, 41, 46, 47], bonus: [8, 9] },
    { date: '2026-05-01', main: [3, 9, 42, 46, 47], bonus: [1, 11] },
    { date: '2026-05-05', main: [3, 4, 8, 20, 31], bonus: [6, 8] },
    { date: '2026-05-08', main: [2, 17, 19, 34, 37], bonus: [8, 11] },
    { date: '2026-05-12', main: [4, 26, 32, 35, 36], bonus: [5, 7] },
    { date: '2026-05-15', main: [3, 10, 38, 41, 43], bonus: [2, 9] },
    { date: '2026-05-19', main: [2, 12, 20, 38, 45], bonus: [2, 5] },
    { date: '2026-05-22', main: [6, 22, 26, 31, 37], bonus: [5, 8] },
    { date: '2026-05-26', main: [6, 23, 25, 35, 37], bonus: [6, 12] },
    { date: '2026-05-29', main: [5, 14, 18, 31, 35], bonus: [2, 12] },
    { date: '2026-06-02', main: [6, 9, 17, 18, 42], bonus: [7, 9] },
    { date: '2026-06-05', main: [5, 6, 16, 17, 49], bonus: [2, 12] },
    { date: '2026-06-09', main: [2, 7, 23, 44, 46], bonus: [3, 5] },
    { date: '2026-06-12', main: [4, 7, 14, 22, 23], bonus: [1, 7] },
    { date: '2026-06-16', main: [18, 25, 31, 37, 45], bonus: [4, 9] },
    { date: '2026-06-19', main: [8, 34, 39, 41, 42], bonus: [2, 7] },
    { date: '2026-06-23', main: [3, 33, 36, 45, 46], bonus: [5, 6] },
    { date: '2026-06-26', main: [6, 16, 26, 34, 35], bonus: [11, 12] },
    { date: '2026-06-30', main: [1, 8, 37, 44, 48], bonus: [2, 6] },
    { date: '2026-07-03', main: [2, 12, 17, 25, 39], bonus: [1, 2] },
    { date: '2026-07-07', main: [5, 29, 33, 45, 47], bonus: [5, 8] },
    { date: '2026-07-10', main: [2, 14, 28, 33, 48], bonus: [8, 10] },
    { date: '2026-07-14', main: [10, 19, 37, 42, 47], bonus: [9, 12] },
    { date: '2026-07-17', main: [12, 21, 23, 34, 40], bonus: [9, 10] },
    { date: '2026-07-21', main: [2, 3, 8, 28, 39], bonus: [2, 11] },
    { date: '2026-07-24', main: [8, 10, 30, 36, 47], bonus: [1, 4] },
    { date: '2026-07-28', main: [5, 7, 24, 30, 49], bonus: [10, 11] },
    { date: '2026-07-31', main: [10, 24, 25, 31, 45], bonus: [4, 5] },
    { date: '2026-08-04', main: [25, 30, 34, 46, 50], bonus: [1, 12] },
    { date: '2026-08-07', main: [26, 29, 35, 38, 47], bonus: [1, 2] },
    { date: '2026-08-11', main: [3, 11, 17, 46, 48], bonus: [1, 2] },
    { date: '2026-08-14', main: [5, 29, 39, 48, 49], bonus: [4, 8] },
    { date: '2026-08-18', main: [3, 9, 38, 40, 50], bonus: [6, 10] },
    { date: '2026-08-21', main: [10, 14, 15, 19, 45], bonus: [4, 12] },
    { date: '2026-08-25', main: [8, 16, 30, 47, 48], bonus: [4, 9] },
    { date: '2026-08-28', main: [7, 14, 28, 42, 45], bonus: [6, 9] },
    { date: '2026-09-01', main: [2, 10, 23, 37, 47], bonus: [3, 5] },
  ],
  eurodreams: [
    { date: '2024-03-04', main: [1, 10, 23, 25, 29, 35], bonus: [1] },
    { date: '2024-03-07', main: [13, 15, 23, 31, 35, 39], bonus: [1] },
    { date: '2024-03-11', main: [2, 7, 14, 22, 37, 39], bonus: [1] },
    { date: '2024-03-14', main: [3, 12, 13, 20, 27, 35], bonus: [2] },
    { date: '2024-03-18', main: [6, 8, 18, 19, 24, 39], bonus: [3] },
    { date: '2024-03-21', main: [3, 8, 27, 30, 33, 37], bonus: [2] },
    { date: '2024-03-25', main: [3, 12, 15, 20, 25, 27], bonus: [3] },
    { date: '2024-03-28', main: [1, 7, 9, 13, 18, 37], bonus: [3] },
    { date: '2024-04-01', main: [3, 10, 15, 18, 26, 38], bonus: [4] },
    { date: '2024-04-04', main: [9, 10, 12, 14, 20, 31], bonus: [5] },
    { date: '2024-04-08', main: [3, 13, 24, 28, 36, 39], bonus: [4] },
    { date: '2024-04-11', main: [17, 19, 22, 30, 35, 37], bonus: [1] },
    { date: '2024-04-15', main: [2, 13, 17, 26, 33, 37], bonus: [5] },
    { date: '2024-04-18', main: [4, 13, 16, 18, 28, 30], bonus: [2] },
    { date: '2024-04-22', main: [6, 23, 24, 31, 32, 39], bonus: [1] },
    { date: '2024-04-25', main: [2, 16, 19, 23, 24, 25], bonus: [1] },
    { date: '2024-04-29', main: [1, 17, 23, 29, 36, 40], bonus: [3] },
    { date: '2024-05-02', main: [4, 10, 16, 17, 26, 30], bonus: [1] },
    { date: '2024-05-06', main: [7, 17, 26, 27, 32, 39], bonus: [3] },
    { date: '2024-05-09', main: [6, 7, 13, 14, 24, 33], bonus: [1] },
    { date: '2024-05-13', main: [9, 20, 23, 24, 37, 39], bonus: [1] },
    { date: '2024-05-16', main: [8, 9, 14, 18, 23, 24], bonus: [3] },
    { date: '2024-05-20', main: [3, 14, 15, 21, 23, 29], bonus: [4] },
    { date: '2024-05-23', main: [7, 8, 13, 14, 23, 31], bonus: [1] },
    { date: '2024-05-27', main: [2, 7, 14, 15, 23, 24], bonus: [3] },
    { date: '2024-05-30', main: [4, 10, 11, 17, 24, 39], bonus: [5] },
    { date: '2024-06-03', main: [1, 3, 11, 22, 34, 38], bonus: [4] },
    { date: '2024-06-06', main: [12, 15, 24, 28, 29, 31], bonus: [1] },
    { date: '2024-06-10', main: [4, 7, 27, 31, 33, 40], bonus: [3] },
    { date: '2024-06-13', main: [17, 19, 21, 22, 23, 27], bonus: [1] },
    { date: '2024-06-17', main: [14, 16, 19, 22, 23, 32], bonus: [4] },
    { date: '2024-06-20', main: [1, 2, 7, 13, 19, 21], bonus: [5] },
    { date: '2024-06-24', main: [5, 13, 16, 20, 23, 30], bonus: [5] },
    { date: '2024-06-27', main: [9, 13, 15, 18, 27, 37], bonus: [2] },
    { date: '2024-07-01', main: [4, 8, 11, 12, 20, 38], bonus: [2] },
    { date: '2024-07-04', main: [4, 8, 22, 23, 27, 33], bonus: [3] },
    { date: '2024-07-08', main: [3, 13, 21, 26, 36, 40], bonus: [3] },
    { date: '2024-07-11', main: [5, 19, 20, 24, 28, 30], bonus: [4] },
    { date: '2024-07-15', main: [15, 19, 21, 23, 28, 40], bonus: [3] },
    { date: '2024-07-18', main: [8, 22, 28, 31, 38, 40], bonus: [1] },
    { date: '2024-07-22', main: [3, 12, 18, 19, 21, 24], bonus: [4] },
    { date: '2024-07-25', main: [3, 16, 18, 27, 30, 37], bonus: [4] },
    { date: '2024-07-29', main: [1, 5, 9, 19, 22, 25], bonus: [3] },
    { date: '2024-08-01', main: [1, 6, 23, 27, 33, 34], bonus: [5] },
    { date: '2024-08-05', main: [3, 10, 13, 16, 31, 38], bonus: [5] },
    { date: '2024-08-08', main: [2, 8, 9, 17, 21, 22], bonus: [2] },
    { date: '2024-08-12', main: [10, 13, 19, 22, 25, 28], bonus: [2] },
    { date: '2024-08-15', main: [6, 14, 20, 34, 38, 40], bonus: [3] },
    { date: '2024-08-19', main: [6, 11, 14, 17, 28, 33], bonus: [5] },
    { date: '2024-08-22', main: [1, 11, 16, 26, 28, 40], bonus: [5] },
    { date: '2024-08-26', main: [5, 6, 8, 12, 30, 32], bonus: [5] },
    { date: '2024-08-29', main: [3, 4, 14, 22, 24, 36], bonus: [4] },
    { date: '2024-09-02', main: [3, 20, 24, 27, 33, 36], bonus: [3] },
    { date: '2024-09-05', main: [8, 19, 24, 31, 32, 40], bonus: [2] },
    { date: '2024-09-09', main: [3, 6, 9, 18, 22, 27], bonus: [3] },
    { date: '2024-09-12', main: [16, 27, 31, 34, 38, 39], bonus: [1] },
    { date: '2024-09-16', main: [12, 18, 21, 28, 31, 32], bonus: [1] },
    { date: '2024-09-19', main: [1, 3, 25, 27, 30, 35], bonus: [3] },
    { date: '2024-09-23', main: [9, 11, 13, 31, 32, 34], bonus: [5] },
    { date: '2024-09-26', main: [9, 19, 21, 31, 32, 39], bonus: [2] },
    { date: '2024-09-30', main: [5, 14, 15, 21, 24, 28], bonus: [3] },
    { date: '2024-10-03', main: [3, 6, 14, 24, 38, 40], bonus: [5] },
    { date: '2024-10-07', main: [4, 14, 24, 28, 34, 40], bonus: [4] },
    { date: '2024-10-10', main: [8, 9, 15, 27, 30, 34], bonus: [3] },
    { date: '2024-10-14', main: [3, 10, 12, 17, 31, 37], bonus: [3] },
    { date: '2024-10-17', main: [6, 15, 22, 26, 33, 37], bonus: [1] },
    { date: '2024-10-21', main: [7, 9, 14, 31, 36, 38], bonus: [4] },
    { date: '2024-10-24', main: [3, 6, 7, 20, 26, 34], bonus: [5] },
    { date: '2024-10-28', main: [7, 8, 13, 15, 27, 33], bonus: [5] },
    { date: '2024-10-31', main: [1, 6, 8, 9, 29, 30], bonus: [4] },
    { date: '2024-11-04', main: [16, 18, 30, 33, 34, 37], bonus: [1] },
    { date: '2024-11-07', main: [4, 15, 17, 21, 25, 34], bonus: [1] },
    { date: '2024-11-11', main: [5, 7, 24, 26, 29, 35], bonus: [1] },
    { date: '2024-11-14', main: [18, 19, 20, 22, 34, 37], bonus: [2] },
    { date: '2024-11-18', main: [8, 13, 21, 22, 28, 33], bonus: [4] },
    { date: '2024-11-21', main: [12, 14, 15, 21, 36, 39], bonus: [5] },
    { date: '2024-11-25', main: [1, 7, 10, 11, 23, 26], bonus: [1] },
    { date: '2024-11-28', main: [4, 5, 12, 28, 32, 37], bonus: [1] },
    { date: '2024-12-02', main: [1, 7, 14, 19, 25, 36], bonus: [2] },
    { date: '2024-12-05', main: [3, 4, 7, 21, 30, 34], bonus: [2] },
    { date: '2024-12-09', main: [10, 16, 17, 23, 26, 35], bonus: [3] },
    { date: '2024-12-12', main: [3, 5, 21, 24, 27, 30], bonus: [1] },
    { date: '2024-12-16', main: [7, 15, 23, 24, 30, 34], bonus: [2] },
    { date: '2024-12-19', main: [3, 6, 7, 10, 16, 32], bonus: [3] },
    { date: '2024-12-23', main: [2, 9, 13, 16, 30, 37], bonus: [5] },
    { date: '2024-12-26', main: [2, 7, 11, 21, 34, 38], bonus: [4] },
    { date: '2024-12-30', main: [8, 15, 21, 24, 31, 40], bonus: [3] },
    { date: '2025-01-02', main: [4, 10, 16, 18, 33, 39], bonus: [2] },
    { date: '2025-01-06', main: [4, 17, 18, 23, 34, 37], bonus: [5] },
    { date: '2025-01-09', main: [5, 19, 22, 28, 38, 40], bonus: [3] },
    { date: '2025-01-13', main: [10, 12, 18, 19, 34, 40], bonus: [2] },
    { date: '2025-01-16', main: [2, 5, 11, 14, 22, 38], bonus: [4] },
    { date: '2025-01-20', main: [2, 4, 7, 16, 18, 36], bonus: [3] },
    { date: '2025-01-23', main: [7, 12, 20, 24, 25, 37], bonus: [2] },
    { date: '2025-01-27', main: [1, 5, 18, 23, 26, 30], bonus: [4] },
    { date: '2025-01-30', main: [9, 20, 28, 35, 38, 40], bonus: [1] },
    { date: '2025-02-03', main: [9, 11, 17, 21, 38, 40], bonus: [2] },
    { date: '2025-02-06', main: [2, 5, 20, 23, 27, 34], bonus: [4] },
    { date: '2025-02-10', main: [9, 11, 26, 29, 36, 38], bonus: [5] },
    { date: '2025-02-13', main: [5, 7, 16, 35, 37, 39], bonus: [5] },
    { date: '2025-02-17', main: [10, 11, 22, 33, 36, 37], bonus: [5] },
    { date: '2025-02-20', main: [4, 8, 9, 18, 24, 36], bonus: [3] },
    { date: '2025-02-24', main: [15, 16, 19, 28, 32, 37], bonus: [1] },
    { date: '2025-02-27', main: [16, 27, 30, 32, 34, 35], bonus: [1] },
    { date: '2025-03-03', main: [3, 10, 12, 29, 30, 36], bonus: [1] },
    { date: '2025-03-06', main: [1, 2, 8, 16, 18, 25], bonus: [2] },
    { date: '2025-03-10', main: [1, 15, 21, 24, 26, 28], bonus: [3] },
    { date: '2025-03-13', main: [13, 16, 18, 24, 29, 30], bonus: [5] },
    { date: '2025-03-17', main: [17, 19, 20, 23, 35, 37], bonus: [3] },
    { date: '2025-03-20', main: [16, 23, 25, 37, 38, 40], bonus: [5] },
    { date: '2025-03-24', main: [3, 11, 26, 27, 28, 37], bonus: [1] },
    { date: '2025-03-27', main: [9, 11, 23, 29, 37, 39], bonus: [1] },
    { date: '2025-03-31', main: [2, 21, 27, 35, 38, 40], bonus: [4] },
    { date: '2025-04-03', main: [7, 13, 16, 22, 32, 33], bonus: [5] },
    { date: '2025-04-07', main: [4, 9, 21, 23, 24, 34], bonus: [4] },
    { date: '2025-04-10', main: [7, 14, 22, 33, 34, 39], bonus: [5] },
    { date: '2025-04-14', main: [4, 11, 15, 21, 30, 36], bonus: [3] },
    { date: '2025-04-17', main: [2, 10, 14, 23, 30, 32], bonus: [2] },
    { date: '2025-04-21', main: [4, 27, 33, 34, 38, 39], bonus: [2] },
    { date: '2025-04-24', main: [3, 4, 19, 23, 33, 36], bonus: [1] },
    { date: '2025-04-28', main: [12, 20, 25, 28, 30, 38], bonus: [1] },
    { date: '2025-05-01', main: [5, 12, 19, 23, 33, 38], bonus: [3] },
    { date: '2025-05-05', main: [10, 19, 23, 25, 32, 39], bonus: [1] },
    { date: '2025-05-08', main: [1, 8, 17, 35, 38, 39], bonus: [2] },
    { date: '2025-05-12', main: [4, 15, 19, 21, 25, 37], bonus: [2] },
    { date: '2025-05-15', main: [11, 15, 24, 26, 32, 37], bonus: [2] },
    { date: '2025-05-19', main: [8, 15, 26, 32, 35, 38], bonus: [2] },
    { date: '2025-05-22', main: [1, 5, 15, 26, 31, 36], bonus: [4] },
    { date: '2025-05-26', main: [2, 17, 18, 21, 25, 35], bonus: [2] },
    { date: '2025-05-29', main: [16, 18, 19, 21, 22, 32], bonus: [5] },
    { date: '2025-06-02', main: [8, 11, 15, 18, 29, 32], bonus: [5] },
    { date: '2025-06-05', main: [10, 17, 19, 28, 31, 32], bonus: [3] },
    { date: '2025-06-09', main: [2, 3, 6, 8, 23, 28], bonus: [2] },
    { date: '2025-06-12', main: [6, 12, 25, 27, 29, 35], bonus: [2] },
    { date: '2025-06-16', main: [6, 17, 23, 29, 30, 35], bonus: [3] },
    { date: '2025-06-19', main: [2, 8, 9, 24, 25, 28], bonus: [1] },
    { date: '2025-06-23', main: [8, 19, 22, 28, 32, 37], bonus: [2] },
    { date: '2025-06-26', main: [4, 7, 19, 22, 24, 35], bonus: [5] },
    { date: '2025-06-30', main: [1, 7, 22, 31, 37, 39], bonus: [5] },
    { date: '2025-07-03', main: [3, 4, 16, 30, 35, 40], bonus: [4] },
    { date: '2025-07-07', main: [8, 14, 17, 24, 26, 29], bonus: [3] },
    { date: '2025-07-10', main: [2, 3, 4, 8, 11, 29], bonus: [2] },
    { date: '2025-07-14', main: [6, 12, 20, 21, 33, 37], bonus: [4] },
    { date: '2025-07-17', main: [4, 10, 12, 26, 28, 29], bonus: [4] },
    { date: '2025-07-21', main: [3, 4, 8, 11, 26, 31], bonus: [1] },
    { date: '2025-07-24', main: [1, 2, 5, 6, 15, 38], bonus: [1] },
    { date: '2025-07-28', main: [4, 19, 25, 26, 38, 40], bonus: [3] },
    { date: '2025-07-31', main: [4, 15, 19, 23, 34, 37], bonus: [5] },
    { date: '2025-08-04', main: [2, 8, 13, 14, 15, 17], bonus: [5] },
    { date: '2025-08-07', main: [3, 14, 23, 28, 33, 34], bonus: [1] },
    { date: '2025-08-11', main: [10, 11, 15, 20, 27, 38], bonus: [3] },
    { date: '2025-08-14', main: [14, 15, 21, 22, 32, 38], bonus: [1] },
    { date: '2025-08-18', main: [1, 31, 33, 35, 36, 40], bonus: [4] },
    { date: '2025-08-21', main: [4, 16, 17, 25, 29, 39], bonus: [3] },
    { date: '2025-08-25', main: [5, 6, 19, 32, 35, 37], bonus: [1] },
    { date: '2025-08-28', main: [6, 7, 11, 15, 16, 35], bonus: [5] },
    { date: '2025-09-01', main: [6, 22, 30, 31, 32, 33], bonus: [4] },
    { date: '2025-09-04', main: [10, 14, 21, 22, 37, 40], bonus: [4] },
    { date: '2025-09-08', main: [1, 3, 5, 11, 20, 31], bonus: [5] },
    { date: '2025-09-11', main: [1, 9, 15, 17, 19, 37], bonus: [2] },
    { date: '2025-09-15', main: [4, 7, 15, 21, 33, 35], bonus: [1] },
    { date: '2025-09-18', main: [11, 17, 26, 32, 36, 37], bonus: [1] },
    { date: '2025-09-22', main: [2, 5, 9, 22, 26, 38], bonus: [5] },
    { date: '2025-09-25', main: [5, 9, 11, 14, 28, 30], bonus: [2] },
    { date: '2025-09-29', main: [9, 10, 25, 33, 35, 40], bonus: [2] },
    { date: '2025-10-02', main: [4, 7, 18, 19, 22, 29], bonus: [1] },
    { date: '2025-10-06', main: [18, 26, 30, 31, 36, 40], bonus: [4] },
    { date: '2025-10-09', main: [1, 3, 4, 8, 20, 30], bonus: [3] },
    { date: '2025-10-13', main: [1, 5, 12, 20, 22, 25], bonus: [1] },
    { date: '2025-10-16', main: [1, 4, 6, 10, 34, 38], bonus: [5] },
    { date: '2025-10-20', main: [8, 18, 21, 25, 32, 33], bonus: [1] },
    { date: '2025-10-23', main: [8, 17, 20, 21, 24, 31], bonus: [5] },
    { date: '2025-10-27', main: [18, 19, 21, 23, 30, 35], bonus: [1] },
    { date: '2025-10-30', main: [9, 14, 18, 22, 33, 39], bonus: [2] },
    { date: '2025-11-03', main: [2, 10, 12, 20, 21, 26], bonus: [2] },
    { date: '2025-11-06', main: [11, 13, 15, 31, 33, 34], bonus: [3] },
    { date: '2025-11-10', main: [1, 8, 10, 19, 21, 37], bonus: [2] },
    { date: '2025-11-13', main: [7, 15, 18, 19, 24, 32], bonus: [2] },
    { date: '2025-11-17', main: [4, 8, 13, 18, 28, 38], bonus: [4] },
    { date: '2025-11-20', main: [7, 17, 20, 28, 30, 31], bonus: [4] },
    { date: '2025-11-24', main: [6, 13, 17, 22, 25, 36], bonus: [4] },
    { date: '2025-11-27', main: [10, 11, 20, 30, 32, 33], bonus: [4] },
    { date: '2025-12-01', main: [12, 15, 19, 23, 33, 38], bonus: [3] },
    { date: '2025-12-04', main: [14, 15, 27, 32, 37, 38], bonus: [3] },
    { date: '2025-12-08', main: [3, 8, 12, 18, 19, 27], bonus: [3] },
    { date: '2025-12-11', main: [4, 6, 21, 23, 32, 37], bonus: [1] },
    { date: '2025-12-15', main: [8, 22, 23, 31, 39, 40], bonus: [4] },
    { date: '2025-12-18', main: [10, 12, 19, 21, 25, 27], bonus: [1] },
    { date: '2025-12-22', main: [4, 11, 24, 27, 34, 35], bonus: [5] },
    { date: '2025-12-25', main: [8, 9, 11, 13, 37, 39], bonus: [4] },
    { date: '2025-12-29', main: [5, 8, 16, 19, 24, 39], bonus: [2] },
    { date: '2026-01-01', main: [2, 6, 14, 20, 24, 27], bonus: [2] },
    { date: '2026-01-05', main: [11, 20, 21, 28, 34, 38], bonus: [4] },
    { date: '2026-01-08', main: [5, 15, 24, 26, 31, 34], bonus: [1] },
    { date: '2026-01-12', main: [9, 15, 18, 23, 27, 31], bonus: [1] },
    { date: '2026-01-15', main: [1, 5, 9, 10, 30, 35], bonus: [2] },
    { date: '2026-01-19', main: [8, 9, 20, 24, 32, 40], bonus: [1] },
    { date: '2026-01-22', main: [4, 7, 10, 17, 25, 39], bonus: [3] },
    { date: '2026-01-26', main: [15, 23, 28, 33, 34, 37], bonus: [3] },
    { date: '2026-01-29', main: [1, 7, 8, 26, 28, 34], bonus: [5] },
    { date: '2026-02-02', main: [2, 7, 23, 24, 32, 37], bonus: [3] },
    { date: '2026-02-05', main: [3, 10, 20, 21, 37, 38], bonus: [3] },
    { date: '2026-02-09', main: [9, 11, 19, 22, 33, 36], bonus: [3] },
    { date: '2026-02-12', main: [17, 27, 30, 33, 34, 36], bonus: [3] },
    { date: '2026-02-16', main: [6, 10, 13, 24, 26, 38], bonus: [3] },
    { date: '2026-02-19', main: [8, 10, 13, 36, 37, 38], bonus: [4] },
    { date: '2026-02-23', main: [1, 7, 12, 25, 26, 39], bonus: [1] },
    { date: '2026-02-26', main: [17, 18, 19, 21, 23, 36], bonus: [4] },
    { date: '2026-03-02', main: [1, 8, 11, 14, 18, 35], bonus: [3] },
    { date: '2026-03-05', main: [6, 18, 22, 32, 37, 38], bonus: [4] },
    { date: '2026-03-09', main: [5, 14, 32, 34, 35, 37], bonus: [3] },
    { date: '2026-03-12', main: [2, 9, 20, 23, 35, 36], bonus: [4] },
    { date: '2026-03-16', main: [2, 5, 24, 29, 32, 39], bonus: [3] },
    { date: '2026-03-19', main: [5, 8, 15, 28, 33, 34], bonus: [3] },
    { date: '2026-03-23', main: [1, 4, 6, 13, 16, 28], bonus: [5] },
    { date: '2026-03-26', main: [11, 14, 30, 32, 34, 39], bonus: [5] },
    { date: '2026-03-30', main: [3, 17, 20, 23, 30, 39], bonus: [3] },
    { date: '2026-04-02', main: [3, 4, 13, 21, 30, 37], bonus: [4] },
    { date: '2026-04-06', main: [1, 2, 8, 14, 28, 33], bonus: [3] },
    { date: '2026-04-09', main: [3, 7, 8, 19, 24, 29], bonus: [5] },
    { date: '2026-04-13', main: [3, 17, 19, 28, 33, 40], bonus: [5] },
    { date: '2026-04-16', main: [23, 24, 28, 29, 31, 40], bonus: [3] },
    { date: '2026-04-20', main: [5, 7, 15, 24, 26, 31], bonus: [4] },
    { date: '2026-04-23', main: [3, 7, 19, 22, 23, 29], bonus: [2] },
    { date: '2026-04-27', main: [1, 4, 14, 21, 29, 34], bonus: [1] },
    { date: '2026-04-30', main: [5, 7, 9, 16, 19, 22], bonus: [2] },
    { date: '2026-05-04', main: [12, 21, 27, 30, 34, 38], bonus: [1] },
    { date: '2026-05-07', main: [9, 12, 13, 24, 32, 38], bonus: [5] },
    { date: '2026-05-11', main: [1, 4, 6, 22, 30, 38], bonus: [5] },
    { date: '2026-05-14', main: [3, 7, 9, 21, 24, 27], bonus: [4] },
    { date: '2026-05-18', main: [3, 11, 16, 20, 21, 22], bonus: [4] },
    { date: '2026-05-21', main: [10, 16, 25, 27, 29, 37], bonus: [5] },
    { date: '2026-05-25', main: [4, 13, 17, 22, 27, 30], bonus: [1] },
    { date: '2026-05-28', main: [11, 12, 17, 22, 25, 35], bonus: [4] },
    { date: '2026-06-01', main: [4, 15, 23, 31, 34, 39], bonus: [3] },
    { date: '2026-06-04', main: [1, 9, 17, 22, 37, 39], bonus: [3] },
    { date: '2026-06-08', main: [2, 4, 9, 22, 28, 34], bonus: [4] },
    { date: '2026-06-11', main: [6, 18, 22, 25, 31, 32], bonus: [5] },
    { date: '2026-06-15', main: [3, 14, 20, 22, 29, 40], bonus: [5] },
    { date: '2026-06-18', main: [2, 19, 23, 27, 28, 30], bonus: [3] },
    { date: '2026-06-22', main: [4, 10, 14, 15, 29, 37], bonus: [3] },
    { date: '2026-06-25', main: [1, 4, 11, 16, 17, 38], bonus: [1] },
    { date: '2026-06-29', main: [12, 20, 22, 28, 29, 40], bonus: [2] },
    { date: '2026-07-02', main: [3, 12, 23, 24, 36, 40], bonus: [3] },
    { date: '2026-07-06', main: [4, 5, 7, 12, 29, 37], bonus: [2] },
    { date: '2026-07-09', main: [5, 14, 18, 22, 33, 35], bonus: [4] },
    { date: '2026-07-13', main: [9, 12, 13, 17, 21, 30], bonus: [1] },
    { date: '2026-07-16', main: [1, 9, 14, 16, 30, 40], bonus: [3] },
    { date: '2026-07-20', main: [8, 11, 12, 22, 26, 36], bonus: [1] },
    { date: '2026-07-23', main: [3, 4, 17, 21, 31, 33], bonus: [2] },
    { date: '2026-07-27', main: [2, 4, 13, 16, 21, 25], bonus: [3] },
    { date: '2026-07-30', main: [4, 12, 21, 27, 34, 39], bonus: [1] },
    { date: '2026-08-03', main: [12, 13, 17, 20, 23, 34], bonus: [2] },
    { date: '2026-08-06', main: [3, 18, 22, 24, 26, 33], bonus: [2] },
    { date: '2026-08-10', main: [7, 9, 10, 26, 33, 40], bonus: [1] },
    { date: '2026-08-13', main: [10, 14, 18, 20, 26, 30], bonus: [5] },
    { date: '2026-08-17', main: [8, 12, 19, 21, 26, 36], bonus: [4] },
    { date: '2026-08-20', main: [19, 20, 24, 28, 30, 33], bonus: [3] },
    { date: '2026-08-24', main: [3, 11, 17, 23, 28, 30], bonus: [2] },
    { date: '2026-08-27', main: [6, 12, 29, 30, 35, 38], bonus: [3] },
    { date: '2026-08-31', main: [6, 14, 15, 17, 34, 37], bonus: [2] },
  ],
};

export const SEED_COVERAGE: {
  readonly [K in GameKey]: { readonly count: number; readonly from: string; readonly to: string };
} = {
  'loto': {
    'count': 409,
    'from': '2024-03-02',
    'to': '2026-09-02'
  },
  'em': {
    'count': 261,
    'from': '2024-03-05',
    'to': '2026-09-01'
  },
  'eurodreams': {
    'count': 261,
    'from': '2024-03-04',
    'to': '2026-08-31'
  }
};
